
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"19","height":"23","viewBox":"0 0 23 31","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11 1H3a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V7l-6-6z","stroke":"#5b5d64","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M11 1v6h6M13 12H5M13 16H5M7 8H5","stroke":"#5b5d64","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('circle',{attrs:{"cx":"14.5","cy":"18.5","r":"5.5","fill":"#fff"}}),_c('g',{attrs:{"filter":"url(#filter0_d)"}},[_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M14.5 14a4.5 4.5 0 110 9 4.5 4.5 0 010-9zm0 .818a3.682 3.682 0 100 7.364 3.682 3.682 0 000-7.364zm0 .818a.41.41 0 01.406.362l.003.048v2.201l1.41.705a.409.409 0 01.202.505l-.019.044a.41.41 0 01-.505.202l-.044-.019-1.636-.818a.41.41 0 01-.223-.315l-.003-.051v-2.454a.41.41 0 01.409-.41z","fill":"#5b5d64"}})]),_c('defs',[_c('filter',{attrs:{"id":"filter0_d","x":"6","y":"14","width":"17","height":"17","filterUnits":"userSpaceOnUse","color-interpolation-filters":"sRGB"}},[_c('feFlood',{attrs:{"flood-opacity":"0","result":"BackgroundImageFix"}}),_c('feColorMatrix',{attrs:{"in":"SourceAlpha","values":"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"}}),_c('feOffset',{attrs:{"dy":"4"}}),_c('feGaussianBlur',{attrs:{"stdDeviation":"2"}}),_c('feColorMatrix',{attrs:{"values":"0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"}}),_c('feBlend',{attrs:{"in2":"BackgroundImageFix","result":"effect1_dropShadow"}}),_c('feBlend',{attrs:{"in":"SourceGraphic","in2":"effect1_dropShadow","result":"shape"}})])])])
          )
        }
      }
    